import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import {getUserInfo, postUserInfo, putUserInfo} from "../../api/apiClient";
import InputUserId from "../../components/inputs/InputUserID";
import InputUserPw from "../../components/inputs/InputUserPW";
import InputUserPwCheck from "../../components/inputs/InputUserPwCheck";
import ComboOgdpDetail from "../../components/inputs/ComboOgdpDetail";
import ComboUserClass from "../../components/inputs/ComboUserClass";
import ComboUserGrade from "../../components/inputs/ComboUserGrade";
import Swal from "sweetalert2";
import '@sweetalert2/theme-dark/dark.scss';

const UserReg = ({
                   propUserId = null,
                   propIsModify = false,
                   hClose = null,
                 }) => {

  const [userInfo, setUserInfo] = useState({
    user_id: '',   // 아이디
    password: '',   // 비밀번호
    user_nm: '',   // 이름
    user_telno: '',    // 전화번호
    ogdp_ty: '',    // 소속구분
    // ogdp_ty_detail: '',   // 소속상세
    user_grade: '',    // 접속권한
    comment: '',   // 사유
    pwCheck: "",  // 비밀번호 확인
  });

  const updateUserInfo = () => {
    if (propUserId != null) {
      getUserInfo(propUserId)
          .then(response => {
            console.log(response);
            // console.log(response.data.data);
            setUserInfo(response.data.data);
          });
    }
  };

  useEffect(() => {
    updateUserInfo();
  }, []);

  const onChangeUserId = (e) => {
    setUserInfo((prev) => {
      return {...prev, user_id: e.target.value};
    })
  };

  const onChangePassword = (e) => {
    setUserInfo((prev) => {
      return {...prev, password: e.target.value};
    })
  };

  const onChangePasswordCheck = (e) => {
    setUserInfo((prev) => {
      return {...prev, pwCheck: e.target.value};
    })
  };

  const onChangeUserNm = (e) => {
    setUserInfo((prev) => {
      return {...prev, user_nm: e.target.value};
    })
  };

  const onChangeUserTelno = (e) => {
    setUserInfo((prev) => {
      return {...prev, user_telno: e.target.value};
    })
  };

  const onChangeOgdpTy = (e) => {
    setUserInfo((prev) => {
      return {...prev, ogdp_ty: e.target.value};
    })
  };

  const onChangeOgdpTyDetail = (e) => {
    // console.log(e.target.value)
    setUserInfo((prev) => {
      return {...prev, ogdp_ty_detail: e.target.value};
    })
  };

  const onChangeUserGrade = (e) => {
    setUserInfo((prev) => {
      return {...prev, user_grade: e.target.value};
    })
  };

  const onChangeComment = (e) => {
    setUserInfo((prev) => {
      return {...prev, comment: e.target.value};
    })
  };

  const onSubmit = () => {
    // user_id: '',   // 아이디
    //     password: '',   // 비밀번호
    //     user_nm: '',   // 이름
    //     user_telno: '',    // 전화번호
    //     ogdp_ty: '',    // 소속구분
    //     // ogdp_ty_detail: '',   // 소속상세
    //     user_grade: '',    // 접속권한
    //     comment: ''   // 사유

    if (userInfo.user_id === '') {
      Swal.fire(
          'ID는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (userInfo.user_nm === '') {
      Swal.fire(
          '이름은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (userInfo.user_telno === '') {
      Swal.fire(
          '전화번호는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (userInfo.ogdp_ty === '') {
      Swal.fire(
          '소속 구분은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (userInfo.user_grade === '') {
      Swal.fire(
          '유저 권한은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (userInfo.comment === '' || userInfo.comment === undefined) {
      Swal.fire(
          '사유는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (userInfo.password !== userInfo.pwCheck) {
      Swal.fire(
          '비밀번호가 일치하지 않습니다.',
          '',
          'error'
      );
      return;
    }

    // api/v1/mgmtuser/users/post/user?userId=test777&password=0000&userNm=test&userTelno=010-0000-0000&ogdpTy=1&userGrade=1&comment=test
    if (propUserId == null) {
      // 등록
      postUserInfo(userInfo)
          .then(res => {
            // console.log(response.data.data);
            let data = res.data;
            Swal.fire(
                '정상적으로 처리 되었습니다!',
                '',
                'success'
            );
            hClose();
          })
          .catch(err => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    } else {
      // 수정
      // 임시 강제 매핑
      let putInfo = {
        user_id: userInfo.user_id,
        password: userInfo.password,
        user_nm: userInfo.user_nm,
        user_telno: userInfo.user_telno,
        ogdp_ty: userInfo.ogdp_ty,
        ogdp_ty_detail: userInfo.ogdp_ty_detail_cd,
        user_grade: userInfo.user_grade,
        comment: userInfo.comment,
        userEmail: "test@test.com"
      };

      // console.log(putInfo);

      putUserInfo(putInfo)
          .then(res => {
            // console.log(res);
            Swal.fire(
                '정상적으로 처리 되었습니다!',
                '',
                'success'
            );
            hClose();
          })
          .catch(err => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    }
  };


  return (
      <Container fluid className={"layer p-2"}>
        <Row className={""}>
          <Col className={''}>
            <Row className={'info-container py-2 mx-3'}>
              <Col md={11} className={'px-5'}>
                <div className={'content-container-body-item'}>
                  <Form
                      className={'user-register-form py-3'}
                      id={'userRegisterForm'}
                  >
                    <Row className={"justify-content-center"}>
                      <Col md={12}>
                        <Row>
                          <Col md={12}>
                            <InputUserId
                                propValue={userInfo.user_id}
                                propOnChange={onChangeUserId}
                            />
                          </Col>
                          <Col md={12}>
                            <InputUserPw
                                propPassword={userInfo.password}
                                propOnChange={onChangePassword}
                            />
                          </Col>
                          <Col md={12}>
                            <InputUserPwCheck
                                propPassword={userInfo.password}
                                propError={""}
                                propOnChange={onChangePasswordCheck}
                            />
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='userName'>
                              <Form.Label column md={3} className={'label text-end fw-bold'}>
                                <span className={"text-danger"}>* </span>이름
                              </Form.Label>
                              <Col md={9}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    onChange={onChangeUserNm}
                                    // defaultValue={userInfo.user_nm || ''}
                                    value={userInfo.user_nm || ''}
                                    required
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='userTelno'>
                              <Form.Label column md={3} className={'label text-end fw-bold'}>
                                <span className={"text-danger"}>* </span>전화번호
                              </Form.Label>
                              <Col md={9}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    onChange={onChangeUserTelno}
                                    // defaultValue={userInfo.user_telno || ''}
                                    value={userInfo.user_telno || ''}
                                    required
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <ComboUserClass
                                propValue={userInfo.ogdp_ty}
                                propOnChange={onChangeOgdpTy}
                                propLocation={"FIELD"}
                            />
                          </Col>

                          <Col md={12}>
                            <ComboOgdpDetail
                                propFilter={userInfo.ogdp_ty}
                                propValue={userInfo.ogdp_ty_detail_cd}
                                propOnChange={onChangeOgdpTyDetail}
                            />
                          </Col>

                          <Col md={12}>
                            <ComboUserGrade
                                propValue={userInfo.user_grade}
                                propOnChange={onChangeUserGrade}
                            />
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='comment'>
                              {propIsModify ?
                                  <Form.Label column md={3} className={'label text-end fw-bold'}>
                                    <span className={"text-danger"}>* </span>수정사유
                                  </Form.Label> :
                                  <Form.Label column md={3} className={'label text-end fw-bold'}>
                                    <span className={"text-danger"}>* </span>등록사유
                                  </Form.Label>
                              }
                              <Col md={9}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    name={'comment'}
                                    onChange={onChangeComment}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                        </Row>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
            </Row>
            <Row className={"my-3 justify-content-center"}>
              <Col md={2} className={'justify-content-center'}>
                <Button type={"button"} className={'btn save-btn w-100'}
                        onClick={onSubmit}>
                  저장
                </Button>
              </Col>
              <Col md={2} className={'justify-content-center text-end'}>
                <Button type={"button"} className={'btn btn-secondary w-100'}
                        onClick={hClose}>
                  취소
                </Button>
              </Col>
            </Row>
          </Col>

        </Row>
      </Container>
  );
};

export default UserReg;
